<div class="supporting-document-upload-container">
	@if (analyseFilesWithAi && onAnalyzeImages) {
		<div class="analyze-docs-section">
			@if (extractionComplete()) {
				<button
					type="button"
					class="analyze-docs-button extraction-complete"
					disabled
				>
					<span class="btn-icon">&#10003;</span>
					Extraction Complete
				</button>
			} @else {
				<button
					type="button"
					class="analyze-docs-button"
					[disabled]="!hasAnyDocuments()"
					(click)="onAnalyzeImagesClick()"
				>
					<span class="btn-icon">&#10024;</span>
					Analyze with AI
				</button>
			}
		</div>
	}
	@if (uploadCards().length === 0) {
		<div class="empty-state">
			<p>No documents required for this company.</p>
		</div>
	} @else {
		<div class="upload-cards">
			@for (card of uploadCards(); track card.document.type) {
			<div
				class="upload-card"
				[class.drag-over]="card.isDragOver"
				(dragover)="onDragOver($event, $index)"
				(dragleave)="onDragLeave($event, $index)"
				(drop)="onDrop($event, $index)"
			>
				<div class="card-header">
					<h3 class="document-label">{{ card.document.label }}</h3>
					@if (card.document.required) {
						<span class="required-badge">Required</span>
					}
				</div>

				@if (!card.file) {
					<div class="upload-area">
						<div class="drop-zone">
							<p class="drop-text">Drag & drop here</p>
							<button
								type="button"
								class="browse-button"
								(click)="openFilePicker($index)"
							>
								BROWSE
							</button>
						</div>
						<p class="instruction-text">Instruction</p>
					</div>
				} @else {
					<div class="file-preview">
						<div class="file-info">
							<div class="file-name-container">
								@if (card.thumbnail) {
									<img [src]="card.thumbnail" alt="File thumbnail" class="file-thumbnail" />
								}
								<span class="file-name">{{ card.fileName }}</span>
							</div>
							<div class="file-actions">
								<button
									type="button"
									class="browse-button replace-button"
									(click)="openFilePicker($index)"
								>
									BROWSE
								</button>
								<button
									type="button"
									class="remove-button"
									(click)="removeFile($index)"
								>
									Remove
								</button>
							</div>
						</div>
					</div>
				}
				<!-- File input always in DOM, just hidden when file exists -->
				<input
					#fileInput
					type="file"
					[accept]="getAcceptString(card.document)"
					(change)="onFileSelected($event, $index)"
					style="display: none"
				/>
			</div>
		}
		</div>
	}
</div>

@if (debugResizeVisible) {
	<div class="resize-debug-backdrop">
		<div class="resize-debug-modal">
			<div class="resize-debug-header">
				<span>Image resize debug: {{ debugResizeFileName }}</span>
				<button type="button" (click)="closeDebugResize()">×</button>
			</div>

			<div class="resize-debug-body">
				<div class="resize-debug-column">
					<h4>Original</h4>
					<p class="resize-debug-size" *ngIf="debugResizeOriginalBytes !== null">
						Size: {{ formatBytes(debugResizeOriginalBytes) }}
					</p>
					<p
						class="resize-debug-size"
						*ngIf="debugResizeOriginalWidth !== null && debugResizeOriginalHeight !== null"
					>
						Dimensions: {{ debugResizeOriginalWidth }} × {{ debugResizeOriginalHeight }} px
					</p>
					<div
						class="resize-debug-image-wrapper"
						*ngIf="debugResizeOriginal"
						[style.aspect-ratio]="
							debugResizeOriginalWidth && debugResizeOriginalHeight
								? debugResizeOriginalWidth + ' / ' + debugResizeOriginalHeight
								: null
						"
					>
						<img
							[src]="debugResizeOriginal"
							alt="Original image"
							class="resize-debug-image"
							[style.transform]="getDebugTransform('original')"
						/>
					</div>
					<div class="resize-debug-controls">
						<label>
							Zoom:
							<input
								type="range"
								min="1"
								max="4"
								step="0.1"
								[value]="debugOriginalZoom"
								(input)="setDebugZoom('original', ($any($event.target).value))"
							/>
						</label>
						<div class="resize-debug-pan-buttons">
							<button type="button" (click)="nudgeDebugOffset('original', 0, -20)">↑</button>
							<button type="button" (click)="nudgeDebugOffset('original', -20, 0)">←</button>
							<button type="button" (click)="nudgeDebugOffset('original', 20, 0)">→</button>
							<button type="button" (click)="nudgeDebugOffset('original', 0, 20)">↓</button>
						</div>
					</div>
				</div>
				<div class="resize-debug-column">
					<h4>Resized</h4>
					<p class="resize-debug-size" *ngIf="debugResizeResizedBytes !== null">
						Size: {{ formatBytes(debugResizeResizedBytes) }}
					</p>
					<p
						class="resize-debug-size"
						*ngIf="debugResizeResizedWidth !== null && debugResizeResizedHeight !== null"
					>
						Dimensions: {{ debugResizeResizedWidth }} × {{ debugResizeResizedHeight }} px
					</p>
					<div
						class="resize-debug-image-wrapper"
						*ngIf="debugResizeResized"
						[style.aspect-ratio]="
							debugResizeResizedWidth && debugResizeResizedHeight
								? debugResizeResizedWidth + ' / ' + debugResizeResizedHeight
								: null
						"
					>
						<img
							[src]="debugResizeResized"
							alt="Resized image"
							class="resize-debug-image"
							[style.transform]="getDebugTransform('resized')"
						/>
					</div>
					<div class="resize-debug-controls">
						<label>
							Zoom:
							<input
								type="range"
								min="1"
								max="4"
								step="0.1"
								[value]="debugResizedZoom"
								(input)="setDebugZoom('resized', ($any($event.target).value))"
							/>
						</label>
						<div class="resize-debug-pan-buttons">
							<button type="button" (click)="nudgeDebugOffset('resized', 0, -20)">↑</button>
							<button type="button" (click)="nudgeDebugOffset('resized', -20, 0)">←</button>
							<button type="button" (click)="nudgeDebugOffset('resized', 20, 0)">→</button>
							<button type="button" (click)="nudgeDebugOffset('resized', 0, 20)">↓</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}
